import { Injectable } from "@angular/core";
import { NgxPermissionsService } from "ngx-permissions";
import {
  CanActivate,
  CanLoad,
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { LocalStorageService } from "./local-storage.service";
import { SettingsConstant } from "./../constants/settings.constants";
import { PermissionUrlService } from './permissions.service';

@Injectable({
  providedIn: "root"
})
export class PermissionGuardService implements CanActivate {
  permissionStatus: boolean;
  perm: Array<String> = [];

  constructor(
    public ngxPermission: NgxPermissionsService,
    public router: Router,
    private localStorage: LocalStorageService,
    private permissions: PermissionUrlService
  ) {
    const scopes = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`);
    this.perm = scopes || [];
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const scopes = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`);
    this.perm = scopes || [];
    const viewPermission = route.data.expectedPermission;
    if (Array.isArray(viewPermission)) {

      if (viewPermission.some(elem => this.perm.indexOf(elem) > -1)) {
        return true;
      } else {
        this.redirectUrlToPermissionPage(this.perm);
        return false;
      }
    } else if (
      this.perm.includes(viewPermission) &&
      !Array.isArray(viewPermission)
    ) {
      return true;
    } else {
      this.router.navigate(["/forbidden"]);
      return false;
    }
  }

  checkPermission(value) {
    if (this.perm.includes(value)) {
      return true;
    } else {
      return false;
    }
  }
  // 666 Redundant Function - not used anywhere
  // getUser = () => {
  //   this.loader.start();
  //   // 666 Use local storage
  //   this.auth0service.getScopePermission(scopes => {
  //     const hasPermission = this.auth0service.removedUnusedScope(scopes, [
  //       "profile",
  //       "openid",
  //       "email"
  //     ]);
  //     this.loader.stop();
  //     if (hasPermission) {
  //       const scope = scopes ? scopes.split(" ") : [];
  //       this.redirectUrlToPermissionPage(scope);  // picked from below and put here
  //       // 666 redudant piece of code
  //       this.auth0service.getProfile(profile => {
  //         const userDetail = this.localStorage.getItem(
  //           SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
  //         );
  //       });
  //       // 666 ends
  //     } else {
  //       this.router.navigate(['/sync-permissions'], { replaceUrl: true })
  //     }
  //   });

  // }

  redirectUrlToPermissionPage(scope) {
    if (scope && scope.length) {
      const userPermissions = scope;
      const performanceDashboardPermissions = [...this.permissions.OVERALL_PERFORMANCE_TAB_DELHIVERY,
      ...this.permissions.OVERALL_PERFORMANCE_TAB_INWARD, ...this.permissions.OVERALL_PERFORMANCE_TAB_TRANSFER,
      ...this.permissions.OVERALL_PERFORMANCE_TAB_RETURN];
      const inventoryPagePermisisons = this.permissions.INVENTORY_DETAIL_PAGE;
      const warehousePermissions = this.permissions.WAREHOUSE_PAGE;
      const transportationPermissions = this.permissions.TRANSPORTATION_PAGE;
      const movementDetailPermissions = this.permissions.MOVEMENT_DETAIL_PAGE;
      const salesForeCastPermissions = this.permissions.SALESFORECAST_PERMISSION_PAGE;
      const overallStatusPage = this.permissions.OVERALL_STATUS_PAGE;
      const pickupRequestPermissions = this.permissions.PICKUP_PAGE_PERMISSIONS;
      const userManagementPermissions = this.permissions.USER_MANAGEMENT;
      const freshDeskPermissions = this.permissions.FRESH_DESK_PERMISSIONS;
      const downloadReportPermissions = this.permissions.DOWNLOAD_REPORTS;
      const clientManagementPermissions = this.permissions.CLIENT_MANAGEMENT;
      if (overallStatusPage.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/overall-status"], { replaceUrl: true });
        return false;
      }
      else if (performanceDashboardPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/performance"], { replaceUrl: true });
        return false;
      } else if (warehousePermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/warehousedashboard"], { replaceUrl: true });
        return false;
      } else if (transportationPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/transportationdashboard"], { replaceUrl: true });
        return false;
      } else if (inventoryPagePermisisons.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/inventorydetailsdashboard"], { replaceUrl: true });
        return false;
      } else if (movementDetailPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/movementdetailsdashboard"], { replaceUrl: true });
        return false;
      } else if (salesForeCastPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/sales-forecast"], { replaceUrl: true });
        return false;
      } else if (pickupRequestPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/pickup-request"], { replaceUrl: true });
        return false;
      } else if (userManagementPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/user-management"], { replaceUrl: true });
      }else if (freshDeskPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/fresh-desk"], { replaceUrl: true });
        return false;
      } else if (downloadReportPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/download-reports"], { replaceUrl: true });
        return false;
      } else if (clientManagementPermissions.some(elem => userPermissions.indexOf(elem) > -1)) {
        this.router.navigate(["/client-management"], { replaceUrl: true });
        return false;
      }
      else {
        this.router.navigate(["/forbidden"], { replaceUrl: true });
        return false;
        // this.permissionExist = true; 
      }
    } else {
      this.router.navigate(["/forbidden"], { replaceUrl: true });
      return false;
    }
  };
}
